export const TIME_REPLENISHMENT_DEFAULT = 12;
